import cookie from "react-cookies";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

export const useGlobalData = () => {
  const token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
  const tenant = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
  const domain = cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN);
  return { token, tenant, domain };
};

